import type { ReactNode } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { clearCredentials, getCredentials } from "../lib/auth";
import { Logo } from "./Logo";

const NAV = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/sales", label: "Sales pipeline" },
  { to: "/tenants", label: "Tenants" },
  { to: "/contracts", label: "Contracts" },
  { to: "/plans", label: "Plans" },
  { to: "/audit", label: "Audit log" },
  { to: "/resources", label: "Resources" },
];

export function Layout() {
  const navigate = useNavigate();
  const creds = getCredentials();

  function logout() {
    clearCredentials();
    navigate("/login", { replace: true });
  }

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <Logo size={30} />
          <span>
            ActionConnect
            <small>Admin Console</small>
          </span>
        </div>
        <nav aria-label="Primary">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="spacer" />
        <div className="who">
          Signed in as
          <br />
          <strong>{creds?.email || "staff@actionconnect.com"}</strong>
        </div>
        <button className="btn small" onClick={logout} style={{ marginTop: 8 }}>
          Sign out
        </button>
      </aside>

      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}

/** Top bar used inside each page for breadcrumbs + page actions. */
export function TopBar({ crumbs, actions }: { crumbs: ReactNode; actions?: ReactNode }) {
  return (
    <header className="topbar">
      <div className="crumbs">{crumbs}</div>
      <div className="btn-row">{actions}</div>
    </header>
  );
}
